"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactAvatar = _interopRequireDefault(require("react-avatar"));
var _Text = _interopRequireDefault(require("../Text"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _CardBlock = _interopRequireDefault(require("../Cards/CardBlock"));
var _system = require("@mui/system");
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var stateMap = {
  0: 'Setup',
  1: 'Commissions',
  2: 'Master Application',
  3: 'Pending Underwriting',
  4: 'Pending Underwriting',
  5: 'Plan Assignment',
  6: 'Request Approval',
  7: 'Under Review',
  8: 'Approved',
  9: 'Sold',
  10: 'Sold'
};
var CardBlockLeft = (0, _system.styled)('div')(function (_ref) {
  var theme = _ref.theme;
  return (0, _defineProperty2["default"])({
    display: 'flex',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'left',
    verticalAlign: 'middle',
    alignItems: 'center',
    width: '70%'
  }, theme.breakpoints.down('500'), {
    width: 'unset'
  });
});
var CardBlockRight = (0, _system.styled)('div')(function (_ref3) {
  var theme = _ref3.theme;
  return (0, _defineProperty2["default"])({
    display: 'inline',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'right',
    verticalAlign: 'middle',
    width: '30%'
  }, theme.breakpoints.down('500'), {
    width: '100%'
  });
});
var CardBlockTop = (0, _system.styled)('div')(function (_ref5) {
  var theme = _ref5.theme;
  return (0, _defineProperty2["default"])({
    borderBottom: "1px solid ".concat(Theme.colors.lightGrey),
    display: 'flex',
    height: 'auto',
    minHeight: '65px',
    width: '100%'
  }, theme.breakpoints.down('500'), {
    flexWrap: 'wrap'
  });
});
var CardBlockBottom = (0, _system.styled)('div')(function (_ref7) {
  var theme = _ref7.theme;
  return (0, _defineProperty2["default"])({
    display: 'flex',
    height: 'auto',
    minHeight: '20px',
    paddingTop: '5px',
    width: '100%'
  }, theme.breakpoints.down('500'), {
    justifyContent: 'space-between'
  });
});

/**
 * 
 * @param {*} props 
 * @returns 
 */
var QuoteCard = function QuoteCard(props) {
  var quote = props.quote,
    whitelabel = props.whitelabel,
    link = props.link;
  return /*#__PURE__*/_react["default"].createElement(_CardBlock["default"], {
    onClick: function onClick() {
      window.location.href = link;
    }
  }, /*#__PURE__*/_react["default"].createElement(CardBlockTop, null, /*#__PURE__*/_react["default"].createElement(CardBlockLeft, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline',
      height: '100%',
      paddingRight: '20px',
      width: '60px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], {
    name: quote.company,
    size: "50",
    textSizeRatio: 2.2,
    round: true,
    fgColor: whitelabel.name ? whitelabel.primaryColor : Theme.colors.skyBlue,
    color: whitelabel.name ? whitelabel.lightColor : Theme.colors.lightBlue
  })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    large: true,
    display: "block"
  }, quote.company)), /*#__PURE__*/_react["default"].createElement(CardBlockRight, {
    style: {
      color: Number(quote.state) === 10 ? whitelabel.primaryColor || Theme.colors.skyBlue : 'black'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "inherit",
    align: "right",
    mediumLarge: true,
    display: "block"
  }, localizationMaps.fromEnglish("quoteStatuses", quote.status)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "inherit",
    align: "right",
    medium: true,
    display: "block"
  }, localizationMaps.fromEnglish("quoteStates", stateMap[quote.state])))), /*#__PURE__*/_react["default"].createElement(CardBlockBottom, null, /*#__PURE__*/_react["default"].createElement(CardBlockLeft, null), /*#__PURE__*/_react["default"].createElement(CardBlockRight, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "inherit",
    tiny: true,
    display: "inline"
  }, _i18n["default"].t(_tokens["default"].labels.advisor.updated), dates.formatDateForDisplay(quote.dateUpdated, 'lll', _i18n["default"].locale)))));
};
var _default = exports["default"] = QuoteCard;